import { Button } from "devextreme-react";

export default function VersionTrackingCell(props) {
  const { data } = props;

  const onClick = async (e) => {};

  return (
    <>
      {data.column.dataField != "otherDocs" && (
        <div style={{ float: "left", marginTop: "5px" }}>{data.value}</div>
      )}

      {((data.column.dataField == "otherDocs" && data.value.length > 0) ||
        (data.column.dataField != "otherDocs" &&
          data.data[data.column.dataField])) && (
        <Button
          style={{ margin: 0, float: "left", height: "20px" }}
          icon="fa-solid fa-file"
          onClick={onClick}
        />
      )}
      {/* {data.data.docs[data.column.dataField] && (
        <Button
          style={{ margin: 0, float: "left", height: "20px" }}
          icon="fa-solid fa-file"
          onClick={onClick}
        />
      )} */}
    </>
  );
}
